import { Button, Col, Select, Row, Form } from "antd";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import EmailIcon from "../../../assets/images/vectors/EmailIcon";
import { useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  PrinterOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useEffect } from "react";

export const InvoiceFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowEmailModal,
  setIsSalesEmail,
  setShowModal,
  selectedRowKeys,
  setFilter,
  params,
  setShowCommonModal,
  showCommonModal,
  invoiceListRefecth,
  handleSavePdf,
  handlePrintPdf,
  exportLoading,
}) => {
  const [form] = Form.useForm();

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/accounts/options/`;
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  // const { role_value } = userData;
  const role_value = userData?.role_value;
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const dealerOptionsUrl = filter?.OemNo
    ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${filter?.OemNo}/dealers/`
    : ![1, 2, 3].includes(role_value) && userData?.oem_no
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${userData?.oem_no}/dealers/`
      : null;
  const { data: dealerOptions } = useGet(dealerOptionsUrl);
  const modifiedDealer = getModifiedResponse(dealerOptions, null);
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  const onSearch = (value) => {
    console.log("search:", value);
  };

  const handleFormChange = (changedValues) => {
    Object.keys(changedValues).forEach((key) => {
      if (key === "Month") {
        const formattedMonth = changedValues[key]
          ? dayjs(changedValues[key]).format("YYYY-MM")
          : null;
        setFilter({ ...filter, Month: formattedMonth });
      } else if (key === "InvoiceTime") {
        setFilter({ ...filter, InvoiceTime: changedValues[key] });
      }
    });
  };

  useEffect(() => {
    const formValues = {};

    if (modParams?.Month) {
      formValues.Month = dayjs(modParams.Month, "YYYY-MM");
    }

    if (modParams?.InvoiceTime) {
      formValues.InvoiceTime = dayjs.unix(Number(modParams.InvoiceTime));
    }

    // Set form values without triggering onChange
    if (Object.keys(formValues).length > 0) {
      form.setFieldsValue(formValues);
    }
  }, [params]);

  return (
    <Form className="" form={form} onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="InvoiceTime"
              placeholder="Invoice Time"
              format="YYYY-MM-DD HH:mm" // 24-hour format
            />
          </Col>
          {[1, 2, 3].includes(role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="label"
                value={filter.OemNo ? Number(filter.OemNo) : undefined}
                onChange={(value) =>
                  setFilter({ ...filter, OemNo: value, DealerNo: null })
                }
                onSearch={onSearch}
                options={modifiedOems}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          )}
          {![7, 8, 9].includes(logData.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Dealer"
                optionFilterProp="label"
                value={filter.DealerNo ? Number(filter.DealerNo) : undefined}
                onChange={(value) =>
                  setFilter({ ...filter, DealerNo: value })
                }
                onSearch={onSearch}
                options={modifiedDealer}
                style={{ width: "100%" }}
                allowClear
                disabled={
                  [1, 2, 3].includes(role_value) &&
                  (filter.OemNo === undefined ||
                    filter.OemNo === null ||
                    filter.OemNo === "")
                }
              />
            </Col>
          )}
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="Month"
              placeholder="Month"
              picker={"month"}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              placeholder="Status"
              optionFilterProp="label"
              value={filter.PaymentStatus || "all"}
              onChange={(value) =>
                setFilter({
                  ...filter,
                  PaymentStatus: value === "all" ? "" : value,
                })
              }
              options={[
                { value: "all", label: "All" },
                {
                  value: "paid",
                  label: (
                    <span>
                      <span className="invoice-status-dot invoice-status-dot-paid" />
                      Paid
                    </span>
                  ),
                },
                {
                  value: "unpaid",
                  label: (
                    <span>
                      <span className="invoice-status-dot invoice-status-dot-unpaid" />
                      Unpaid
                    </span>
                  ),
                },
                {
                  value: "overdue",
                  label: (
                    <span>
                      <span className="invoice-status-dot invoice-status-dot-overdue" />
                      Overdue
                    </span>
                  ),
                },
              ]}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
      </div>

      <div className="flex justify-between my-4 overflow-x-auto !items-center">
        <div className="flex items-center">
          <Button
            type="primary"
            className="mr-2 w-[104px] h-[30px] font-medium"
            onClick={handleFilter}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span>Apply</span>
          </Button>
          <Button
            className="reset-button w-[104px] h-[30px] font-medium"
            onClick={() => {
              form.resetFields();
              handleReset();
            }}
          >
            <HiArrowPath className="!text-[14px] font-medium" />
            Reset
          </Button>
          {[1, 2, 3].includes(role_value) && (
            <>
              <Button
                type="primary"
                className="ml-2 w-[104px] h-[30px] font-medium"
                disabled={selectedRowKeys?.length === 0 ? true : false}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <DeleteOutlined className="" />
                Delete
              </Button>
            </>
          )}

          {[1, 2, 3].includes(role_value) && (
            <Button
              type="primary"
              className="ml-2 w-[104px] h-[32px] font-medium"
              onClick={() => {
                setIsSalesEmail(false);
                setShowEmailModal(true);
              }}
              disabled={selectedRowKeys?.length === 0 ? true : false}
            >
              <EmailIcon color="white" size={16} />
              Email
            </Button>
          )}
          {[1, 2, 3].includes(role_value) && (
            <Button
              type="primary"
              className="ml-2 w-[140px] h-[32px] font-medium"
              onClick={() => {
                setIsSalesEmail(true);
                setShowEmailModal(true);
              }}
              disabled={selectedRowKeys?.length === 0 ? true : false}
            >
              <EmailIcon color="white" size={16} />
              Email to Sales
            </Button>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="primary"
            className="w-[104px] h-[30px] font-medium"
            onClick={handleSavePdf}
            loading={exportLoading}
          >
            <SaveOutlined className="!text-[14px] font-medium" />
            Save
          </Button>
          <Button
            type="primary"
            className="w-[104px] h-[30px] font-medium"
            onClick={handlePrintPdf}
            loading={exportLoading}
          >
            <PrinterOutlined className="!text-[14px] font-medium" />
            Print
          </Button>
        </div>
      </div>
    </Form>
  );
};
